<div class="component" (click)="onClickComponent()">
    <span class="plus fa fa-plus"></span>
    <span class="bell fa fa-bell"></span>
</div>